import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://qyzkvzkmnndphnesbzke.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5emt2emttbm5kcGhuZXNiemtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5NjQ2OTQsImV4cCI6MjA5MzU0MDY5NH0.q4iPbn1SXwjZe8iYJn4c2N3Bco92MimAoAsqKoDYZqY'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
